import {
  SecondhandTaxesLandingPageSection,
  NO_CHANGES_TO_TAXES_IMAGE_BASE_URL,
} from '../../constants'

export const getBannerSectionContent = (countryCode = 'UK') => {
  const imageBannerSectionUrl = `${NO_CHANGES_TO_TAXES_IMAGE_BASE_URL}/${countryCode}/DAC7-illustration-banner-540x387`

  return {
    componentId: SecondhandTaxesLandingPageSection.Banner,
    testId: 'no-changes-to-taxes--banner-section',
    text: {
      caption: 'secondhand_taxes.banner.caption',
      title: 'secondhand_taxes.banner.title',
    },
    image: {
      src: `${imageBannerSectionUrl}.png`,
      srcSet: `${imageBannerSectionUrl}.png 1x, ${imageBannerSectionUrl}@2x.png 2x, ${imageBannerSectionUrl}@3x.png 3x,`,
    },
  }
}
